import { GetterTree } from 'vuex';
import { ConfigurationState, Environment, AppBarSettings, AppWindowSettings } from './types';
import { RootState } from '@/vuex/types';
import { AppTheme, AppComponentsVisibility } from '@/plugins/vuetify/themes/types';

export const getters: GetterTree<ConfigurationState, RootState> = {
    appBarSettings(state): AppBarSettings {
        return state.appBarSettings;
    },
    appWindowSettings(state): AppWindowSettings {
        return state.appWindowSettings;
    },
    environment(state): Environment {
        return state.environment;
    },
    environments(state): { [name: string]: Environment } {
        return state.environments;
    },
    apiUrl(state): string {
        return state.environment.apiUrl;
    },
    componentsVisibility(state): AppComponentsVisibility {
        return state.appTheme.visibility;
    },
    appTheme(state): AppTheme {
        return state.appTheme;
    },
    appThemes(state): { [name: string]: AppTheme } {
        return state.appThemes;
    },
};
